import { useRef } from "react";
import { getQuantityCellsBySchedule } from "views/components/Schedules/utils/helpers";
import ScheduleActivity from "../components/ScheduleActivity";
import useUpdateActivityPopupWithExitConfirmation from "views/components/Schedules/components/UpdateActivityPopup/hooks/useUpdateActivityPopupWithExitConfirmation";
import AdminReservationView from "./AdminReservationView";

const AdminReservationActivity = ({
	adminReservation, 
	openConfirmExitWithoutSavingDialog
}) => {
	const {
		name, details, schedule 
	} = adminReservation;
	const quantityCells = getQuantityCellsBySchedule(schedule);
    const $activity = useRef();
	const updateActivityPopup = useUpdateActivityPopupWithExitConfirmation({
        $activity
    });
	return (
		<ScheduleActivity
			classList={["manual"]}
			header={{
				title: name,
				subtitle: details
			}}
			quantityCells={quantityCells}
			reservation={adminReservation}
			$activity={$activity}
			updateActivityPopup={updateActivityPopup}
			openConfirmExitWithoutSavingDialog={openConfirmExitWithoutSavingDialog}>
			<AdminReservationView 
				updateActivityPopup={updateActivityPopup}
				adminReservation={adminReservation}/>
		</ScheduleActivity>
	);
}

export default AdminReservationActivity;